import _asyncToGenerator from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _classCallCheck from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _regeneratorRuntime from "/vercel/path0/node_modules/@babel/runtime/regenerator/index.js";
import { utils } from '@pixi/core';
import '../utils/index.mjs';
import { isSingleItem } from '../utils/isSingleItem.mjs';
import { convertToList } from '../utils/convertToList.mjs';
var Loader = /*#__PURE__*/function () {
  function Loader() {
    _classCallCheck(this, Loader);
    this._parsers = [];
    this.promiseCache = {};
  }
  _createClass(Loader, [{
    key: "reset",
    value: function reset() {
      this.promiseCache = {};
    }
  }, {
    key: "_getLoadPromiseAndParser",
    value: function _getLoadPromiseAndParser(url, data) {
      var _this = this;
      var result = {
        promise: null,
        parser: null
      };
      result.promise = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var asset, i, _parser$test, parser, _i, _parser, _parser$testParse;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              asset = null;
              i = 0;
            case 2:
              if (!(i < _this.parsers.length)) {
                _context.next = 13;
                break;
              }
              parser = _this.parsers[i];
              if (!(parser.load && (_parser$test = parser.test) !== null && _parser$test !== void 0 && _parser$test.call(parser, url, data, _this))) {
                _context.next = 10;
                break;
              }
              _context.next = 7;
              return parser.load(url, data, _this);
            case 7:
              asset = _context.sent;
              result.parser = parser;
              return _context.abrupt("break", 13);
            case 10:
              i++;
              _context.next = 2;
              break;
            case 13:
              if (result.parser) {
                _context.next = 16;
                break;
              }
              console.warn("[Assets] ".concat(url, " could not be loaded as we don't know how to parse it, ensure the correct parser has being added"));
              return _context.abrupt("return", null);
            case 16:
              _i = 0;
            case 17:
              if (!(_i < _this.parsers.length)) {
                _context.next = 36;
                break;
              }
              _parser = _this.parsers[_i];
              if (!_parser.parse) {
                _context.next = 33;
                break;
              }
              _context.t0 = _parser.parse;
              if (!_context.t0) {
                _context.next = 25;
                break;
              }
              _context.next = 24;
              return (_parser$testParse = _parser.testParse) === null || _parser$testParse === void 0 ? void 0 : _parser$testParse.call(_parser, asset, data, _this);
            case 24:
              _context.t0 = _context.sent;
            case 25:
              if (!_context.t0) {
                _context.next = 33;
                break;
              }
              _context.next = 28;
              return _parser.parse(asset, data, _this);
            case 28:
              _context.t1 = _context.sent;
              if (_context.t1) {
                _context.next = 31;
                break;
              }
              _context.t1 = asset;
            case 31:
              asset = _context.t1;
              result.parser = _parser;
            case 33:
              _i++;
              _context.next = 17;
              break;
            case 36:
              return _context.abrupt("return", asset);
            case 37:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
      return result;
    }
  }, {
    key: "load",
    value: function () {
      var _load = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(assetsToLoadIn, onProgress) {
        var _this2 = this;
        var count, assets, singleAsset, assetsToLoad, total, promises;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              count = 0;
              assets = {};
              singleAsset = isSingleItem(assetsToLoadIn);
              assetsToLoad = convertToList(assetsToLoadIn, function (item) {
                return {
                  src: item
                };
              });
              total = assetsToLoad.length;
              promises = assetsToLoad.map( /*#__PURE__*/function () {
                var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(asset) {
                  var url;
                  return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) switch (_context2.prev = _context2.next) {
                      case 0:
                        url = utils.path.toAbsolute(asset.src);
                        if (assets[asset.src]) {
                          _context2.next = 15;
                          break;
                        }
                        _context2.prev = 2;
                        if (!_this2.promiseCache[url]) {
                          _this2.promiseCache[url] = _this2._getLoadPromiseAndParser(url, asset);
                        }
                        _context2.next = 6;
                        return _this2.promiseCache[url].promise;
                      case 6:
                        assets[asset.src] = _context2.sent;
                        if (onProgress) onProgress(++count / total);
                        _context2.next = 15;
                        break;
                      case 10:
                        _context2.prev = 10;
                        _context2.t0 = _context2["catch"](2);
                        delete _this2.promiseCache[url];
                        delete assets[asset.src];
                        throw new Error("[Loader.load] Failed to load ".concat(url, ".\n").concat(_context2.t0));
                      case 15:
                      case "end":
                        return _context2.stop();
                    }
                  }, _callee2, null, [[2, 10]]);
                }));
                return function (_x3) {
                  return _ref2.apply(this, arguments);
                };
              }());
              _context3.next = 8;
              return Promise.all(promises);
            case 8:
              return _context3.abrupt("return", singleAsset ? assets[assetsToLoad[0].src] : assets);
            case 9:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }));
      function load(_x, _x2) {
        return _load.apply(this, arguments);
      }
      return load;
    }()
  }, {
    key: "unload",
    value: function () {
      var _unload = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(assetsToUnloadIn) {
        var _this3 = this;
        var assetsToUnload, promises;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              assetsToUnload = convertToList(assetsToUnloadIn, function (item) {
                return {
                  src: item
                };
              });
              promises = assetsToUnload.map( /*#__PURE__*/function () {
                var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(asset) {
                  var url, loadPromise, _loadPromise$parser, _loadPromise$parser$u, loadedAsset;
                  return _regeneratorRuntime.wrap(function _callee4$(_context4) {
                    while (1) switch (_context4.prev = _context4.next) {
                      case 0:
                        url = utils.path.toAbsolute(asset.src);
                        loadPromise = _this3.promiseCache[url];
                        if (!loadPromise) {
                          _context4.next = 8;
                          break;
                        }
                        _context4.next = 5;
                        return loadPromise.promise;
                      case 5:
                        loadedAsset = _context4.sent;
                        (_loadPromise$parser = loadPromise.parser) === null || _loadPromise$parser === void 0 ? void 0 : (_loadPromise$parser$u = _loadPromise$parser.unload) === null || _loadPromise$parser$u === void 0 ? void 0 : _loadPromise$parser$u.call(_loadPromise$parser, loadedAsset, asset, _this3);
                        delete _this3.promiseCache[url];
                      case 8:
                      case "end":
                        return _context4.stop();
                    }
                  }, _callee4);
                }));
                return function (_x5) {
                  return _ref3.apply(this, arguments);
                };
              }());
              _context5.next = 4;
              return Promise.all(promises);
            case 4:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }));
      function unload(_x4) {
        return _unload.apply(this, arguments);
      }
      return unload;
    }()
  }, {
    key: "parsers",
    get: function get() {
      return this._parsers;
    }
  }]);
  return Loader;
}();
export { Loader };